import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ANNIE_STUDIO } from "@/theme/tokens";
import { AssistantAvatarMood } from "@/ui/AssistantAvatar/assistantAvatarConfig";
import { type SystemChipItem, SystemChips } from "@/ui/Clickable/TabsAndChips/SystemChips/SystemChips";

const MOOD_ORDER = Object.values(AssistantAvatarMood);

type Props = {
	mood: AssistantAvatarMood;
	/** Called on every pick, including the current mood, so a one-shot can be replayed. */
	onMoodChange: (mood: AssistantAvatarMood) => void;
	disabled: boolean;
	compact: boolean;
};

/** The six moods to preview on the stage. */
export const AnnieStudioMoodChips: FC<Props> = ({ mood, onMoodChange, disabled, compact }) => {
	const { t } = useTranslation();
	const items: SystemChipItem<AssistantAvatarMood>[] = MOOD_ORDER.map((value) => ({ value, label: t(`annie.avatar.mood.${value}`) }));
	return (
		<SystemChips
			items={items}
			selectedItems={items.filter((item) => item.value === mood)}
			onChange={(item) => onMoodChange(item.value)}
			variant="outlined"
			dataTestId="annie-studio-moods"
			getItemDataTestId={(item) => `annie-studio-mood-${item.value}`}
			rootSx={{
				gap: 0.75,
				justifyContent: compact ? "flex-start" : "center",
				pointerEvents: disabled ? "none" : "auto",
				opacity: disabled ? ANNIE_STUDIO.HIDDEN_OPACITY : 1,
			}}
		/>
	);
};
